import type { Socket } from "socket.io-client";
import type { ServerToClientEvents, ClientToServerEvents } from "@amzn/a4k-creator-studio-shared";
import { useConfigStore } from "../configStore";
import { stopAccessRetry } from "./connectionHandlers";

type TypedSocket = Socket<ServerToClientEvents, ClientToServerEvents>;

export function registerSessionInfoHandlers(
  socket: TypedSocket,
  set: (partial: Partial<{ hasExistingStory: boolean; storyTitle: string | null; sessionInfoReceived: boolean; accessBlocked: string | null }>) => void,
): void {
  socket.on("sessionInfo", (data) => {
    stopAccessRetry();
    set({ hasExistingStory: data.hasExistingStory, storyTitle: data.storyTitle, sessionInfoReceived: true, accessBlocked: null });
    useConfigStore.getState().replaceAll(data.config);
    useConfigStore.getState().setModerationAvailable(data.moderationAvailable);
    useConfigStore.getState().setFeatureFlags(data.featureFlags);
  });
}
